import { Pipe, PipeTransform } from '@angular/core';
import {CurrencyService} from './_services/currency.service';

@Pipe({
  name: 'replaceEuro'
})
export class ReplaceEuroPipe implements PipeTransform {
  constructor(private currencyService: CurrencyService) {}
  transform(value: any, args?: any): any {
    return this.currencyService.replaceEuro(value);
  }

}
